import { prefixObjectValues } from '../../utils';
const form = {
  id: 'form',
  firstNameInput: 'first-name-input',
  lastNameInput: 'last-name-input',
  middleNameInput: 'middle-name-input',
  prefixDropdown: 'prefix-dropdown',
  suffixDropdown: 'suffix-dropdown',
  dateOfBirth: 'dateOfBirth',
  gender: 'gender-dropdown',
  placeOfBirth: 'placeOfBirth-input',
  citizenshipDropdown: 'citizenship-dropdown',
  visaTypeDropdown: 'visatype-dropdown',
  visaStatusDropdown: 'visaStatus-dropdown',
  submitBtn: 'submit-button',
  birthCity: 'birth-city',
  birthState: 'birth-state',
  birthCountry: 'birth-country',
};

export default prefixObjectValues(form, 'profile-personal-info-form');
